import get from 'lodash.get'
import nb from './nb'

const _locales = {nb}
let _locale = 'nb'

export function setLocale(locale) {
  _locale = locale
}

export default function(key) {
  const defaultValue = key.split('.').pop()
  return get(_locales, `${_locale}.${key}`, defaultValue)
}
